/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CatchAllRouteImport } from './routes/catchAll'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as AssortmentIndexRouteImport } from './routes/assortment/index'
import { Route as AssortmentSearchRouteImport } from './routes/assortment/search'
import { Route as AssortmentTypesRouteImport } from './routes/assortment/types'
import { Route as BulkSmsIndexRouteImport } from './routes/bulk-sms/index'
import { Route as ContractorContractorIdRouteImport } from './routes/contractor/$contractorId'
import { Route as ContractorRegisterRouteImport } from './routes/contractor/register'
import { Route as ContractorSearchRouteImport } from './routes/contractor/search'
import { Route as ForestownerIndexRouteImport } from './routes/forestowner/index'
import { Route as ForestownerForestownerIdRouteImport } from './routes/forestowner/$forestownerId'
import { Route as ForestownerAuthTestRouteImport } from './routes/forestowner/auth-test'
import { Route as ForestownerRegisterRouteImport } from './routes/forestowner/register'
import { Route as ForestownerSearchRouteImport } from './routes/forestowner/search'
import { Route as FrameworkIndexRouteImport } from './routes/framework/index'
import { Route as FrameworkSearchRouteImport } from './routes/framework/search'
import { Route as SearchIndexRouteImport } from './routes/search/index'
import { Route as SearchEditRouteImport } from './routes/search/edit'
import { Route as ShareholderRegisterRouteImport } from './routes/shareholder/register'
import { Route as TimberbuyerIndexRouteImport } from './routes/timberbuyer/index'
import { Route as TimberbuyerTimberBuyerIdRouteImport } from './routes/timberbuyer/$timberBuyerId'
import { Route as TimberbuyerRegisterRouteImport } from './routes/timberbuyer/register'
import { Route as TimberbuyerSearchRouteImport } from './routes/timberbuyer/search'
import { Route as ContractorContractorIdIndexRouteImport } from './routes/contractor/$contractorId/index'
import { Route as ContractorContractorIdDocumentsRouteImport } from './routes/contractor/$contractorId/documents'
import { Route as ContractorContractorIdHistoryRouteImport } from './routes/contractor/$contractorId/history'
import { Route as ContractorContractorIdResourcesRouteRouteImport } from './routes/contractor/$contractorId/resources/route'
import { Route as ForestownerForestownerIdIndexRouteImport } from './routes/forestowner/$forestownerId/index'
import { Route as ForestownerForestownerIdAssignmentsRouteImport } from './routes/forestowner/$forestownerId/assignments'
import { Route as ForestownerForestownerIdDocumentsRouteImport } from './routes/forestowner/$forestownerId/documents'
import { Route as ForestownerForestownerIdEconomyRouteImport } from './routes/forestowner/$forestownerId/economy'
import { Route as ForestownerForestownerIdFscRouteImport } from './routes/forestowner/$forestownerId/fsc'
import { Route as ForestownerForestownerIdHistoryRouteImport } from './routes/forestowner/$forestownerId/history'
import { Route as FrameworkForestownerForestownerIdRouteImport } from './routes/framework/forestowner/$forestownerId'
import { Route as TimberbuyerTimberBuyerIdIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/index'
import { Route as ContractorContractorIdEditIndexRouteImport } from './routes/contractor/$contractorId/edit/index'
import { Route as ContractorContractorIdEmployeesEmployeeIdRouteImport } from './routes/contractor/$contractorId/employees/$employeeId'
import { Route as ContractorContractorIdEmployeesAddRouteImport } from './routes/contractor/$contractorId/employees/add'
import { Route as ContractorContractorIdForestCrewsForestCrewIdRouteImport } from './routes/contractor/$contractorId/forest-crews/$forestCrewId'
import { Route as ContractorContractorIdForestCrewsAddRouteImport } from './routes/contractor/$contractorId/forest-crews/add'
import { Route as ContractorContractorIdMachinesAddRouteImport } from './routes/contractor/$contractorId/machines/add'
import { Route as ContractorContractorIdResourcesIndexRouteImport } from './routes/contractor/$contractorId/resources/index'
import { Route as ContractorContractorIdResourcesForestCrewsRouteImport } from './routes/contractor/$contractorId/resources/forest-crews'
import { Route as ContractorContractorIdResourcesMachinesRouteImport } from './routes/contractor/$contractorId/resources/machines'
import { Route as ContractorContractorIdSendSMSIndexRouteImport } from './routes/contractor/$contractorId/sendSMS/index'
import { Route as ForestownerForestownerIdContactpreferencesIndexRouteImport } from './routes/forestowner/$forestownerId/contactpreferences/index'
import { Route as ForestownerForestownerIdEditIndexRouteImport } from './routes/forestowner/$forestownerId/edit/index'
import { Route as ForestownerForestownerIdPropertyIndexRouteImport } from './routes/forestowner/$forestownerId/property/index'
import { Route as ForestownerForestownerIdPropertyAddRouteImport } from './routes/forestowner/$forestownerId/property/add'
import { Route as ForestownerForestownerIdPropertySupplierNumberRouteImport } from './routes/forestowner/$forestownerId/property/supplier-number'
import { Route as ForestownerForestownerIdSendSMSIndexRouteImport } from './routes/forestowner/$forestownerId/sendSMS/index'
import { Route as ForestownerForestownerIdShareownershipIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/index'
import { Route as FrameworkForestownerForestownerIdIndexRouteImport } from './routes/framework/forestowner/$forestownerId/index'
import { Route as FrameworkForestownerForestownerIdAssignmentsRouteImport } from './routes/framework/forestowner/$forestownerId/assignments'
import { Route as FrameworkForestownerForestownerIdDocumentsRouteImport } from './routes/framework/forestowner/$forestownerId/documents'
import { Route as FrameworkForestownerForestownerIdEconomyRouteImport } from './routes/framework/forestowner/$forestownerId/economy'
import { Route as FrameworkForestownerForestownerIdFscRouteImport } from './routes/framework/forestowner/$forestownerId/fsc'
import { Route as FrameworkForestownerForestownerIdHistoryRouteImport } from './routes/framework/forestowner/$forestownerId/history'
import { Route as FrameworkForestownerForestownerIdPropertyRouteImport } from './routes/framework/forestowner/$forestownerId/property'
import { Route as FrameworkForestownerForestownerIdShareownershipRouteImport } from './routes/framework/forestowner/$forestownerId/shareownership'
import { Route as TimberbuyerTimberBuyerIdContactpreferencesIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/contactpreferences/index'
import { Route as TimberbuyerTimberBuyerIdDeliveryLocationsIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/delivery-locations/index'
import { Route as TimberbuyerTimberBuyerIdEditIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/edit/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsRegisterRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/register'
import { Route as ContractorContractorIdEmployeesEmployeeIdEditRouteImport } from './routes/contractor/$contractorId/employees/$employeeId/edit'
import { Route as ContractorContractorIdMachinesMachineIdEditRouteImport } from './routes/contractor/$contractorId/machines/$machineId/edit'
import { Route as ForestownerForestownerIdContactpreferencesExceptionsIndexRouteImport } from './routes/forestowner/$forestownerId/contactpreferences/exceptions/index'
import { Route as ForestownerForestownerIdPropertyPropertyIdIndexRouteImport } from './routes/forestowner/$forestownerId/property/$propertyId/index'
import { Route as ForestownerForestownerIdPropertyProtectedAreaEditRouteImport } from './routes/forestowner/$forestownerId/property/protected-area/edit'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/index'
import { Route as ContractorContractorIdForestCrewsForestCrewIdEditIndexRouteImport } from './routes/contractor/$contractorId/forest-crews/$forestCrewId/edit/index'
import { Route as ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRouteImport } from './routes/forestowner/$forestownerId/property/$propertyId/protected-area/edit'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/index'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/index'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/index'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/partner/index'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/index'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/index'
import { Route as ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRouteImport } from './routes/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/index'
import { Route as TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRouteImport } from './routes/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatchAllRoute = CatchAllRouteImport.update({
  id: '/catchAll',
  path: '/catchAll',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AssortmentIndexRoute = AssortmentIndexRouteImport.update({
  id: '/assortment/',
  path: '/assortment/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssortmentSearchRoute = AssortmentSearchRouteImport.update({
  id: '/assortment/search',
  path: '/assortment/search',
  getParentRoute: () => rootRouteImport,
} as any)
const AssortmentTypesRoute = AssortmentTypesRouteImport.update({
  id: '/assortment/types',
  path: '/assortment/types',
  getParentRoute: () => rootRouteImport,
} as any)
const BulkSmsIndexRoute = BulkSmsIndexRouteImport.update({
  id: '/bulk-sms/',
  path: '/bulk-sms/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorContractorIdRoute = ContractorContractorIdRouteImport.update({
  id: '/contractor/$contractorId',
  path: '/contractor/$contractorId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorRegisterRoute = ContractorRegisterRouteImport.update({
  id: '/contractor/register',
  path: '/contractor/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorSearchRoute = ContractorSearchRouteImport.update({
  id: '/contractor/search',
  path: '/contractor/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ForestownerIndexRoute = ForestownerIndexRouteImport.update({
  id: '/forestowner/',
  path: '/forestowner/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForestownerForestownerIdRoute =
  ForestownerForestownerIdRouteImport.update({
    id: '/forestowner/$forestownerId',
    path: '/forestowner/$forestownerId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ForestownerAuthTestRoute = ForestownerAuthTestRouteImport.update({
  id: '/forestowner/auth-test',
  path: '/forestowner/auth-test',
  getParentRoute: () => rootRouteImport,
} as any)
const ForestownerRegisterRoute = ForestownerRegisterRouteImport.update({
  id: '/forestowner/register',
  path: '/forestowner/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ForestownerSearchRoute = ForestownerSearchRouteImport.update({
  id: '/forestowner/search',
  path: '/forestowner/search',
  getParentRoute: () => rootRouteImport,
} as any)
const FrameworkIndexRoute = FrameworkIndexRouteImport.update({
  id: '/framework/',
  path: '/framework/',
  getParentRoute: () => rootRouteImport,
} as any)
const FrameworkSearchRoute = FrameworkSearchRouteImport.update({
  id: '/framework/search',
  path: '/framework/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchIndexRoute = SearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchEditRoute = SearchEditRouteImport.update({
  id: '/search/edit',
  path: '/search/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareholderRegisterRoute = ShareholderRegisterRouteImport.update({
  id: '/shareholder/register',
  path: '/shareholder/register',
  getParentRoute: () => rootRouteImport,
} as any)
const TimberbuyerIndexRoute = TimberbuyerIndexRouteImport.update({
  id: '/timberbuyer/',
  path: '/timberbuyer/',
  getParentRoute: () => rootRouteImport,
} as any)
const TimberbuyerTimberBuyerIdRoute =
  TimberbuyerTimberBuyerIdRouteImport.update({
    id: '/timberbuyer/$timberBuyerId',
    path: '/timberbuyer/$timberBuyerId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TimberbuyerRegisterRoute = TimberbuyerRegisterRouteImport.update({
  id: '/timberbuyer/register',
  path: '/timberbuyer/register',
  getParentRoute: () => rootRouteImport,
} as any)
const TimberbuyerSearchRoute = TimberbuyerSearchRouteImport.update({
  id: '/timberbuyer/search',
  path: '/timberbuyer/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorContractorIdIndexRoute =
  ContractorContractorIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdDocumentsRoute =
  ContractorContractorIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdHistoryRoute =
  ContractorContractorIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdResourcesRouteRoute =
  ContractorContractorIdResourcesRouteRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ForestownerForestownerIdIndexRoute =
  ForestownerForestownerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdAssignmentsRoute =
  ForestownerForestownerIdAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdDocumentsRoute =
  ForestownerForestownerIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdEconomyRoute =
  ForestownerForestownerIdEconomyRouteImport.update({
    id: '/economy',
    path: '/economy',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdFscRoute =
  ForestownerForestownerIdFscRouteImport.update({
    id: '/fsc',
    path: '/fsc',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdHistoryRoute =
  ForestownerForestownerIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdRoute =
  FrameworkForestownerForestownerIdRouteImport.update({
    id: '/framework/forestowner/$forestownerId',
    path: '/framework/forestowner/$forestownerId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TimberbuyerTimberBuyerIdIndexRoute =
  TimberbuyerTimberBuyerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const ContractorContractorIdEditIndexRoute =
  ContractorContractorIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdEmployeesEmployeeIdRoute =
  ContractorContractorIdEmployeesEmployeeIdRouteImport.update({
    id: '/employees/$employeeId',
    path: '/employees/$employeeId',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdEmployeesAddRoute =
  ContractorContractorIdEmployeesAddRouteImport.update({
    id: '/employees/add',
    path: '/employees/add',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdForestCrewsForestCrewIdRoute =
  ContractorContractorIdForestCrewsForestCrewIdRouteImport.update({
    id: '/forest-crews/$forestCrewId',
    path: '/forest-crews/$forestCrewId',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdForestCrewsAddRoute =
  ContractorContractorIdForestCrewsAddRouteImport.update({
    id: '/forest-crews/add',
    path: '/forest-crews/add',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdMachinesAddRoute =
  ContractorContractorIdMachinesAddRouteImport.update({
    id: '/machines/add',
    path: '/machines/add',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ContractorContractorIdResourcesIndexRoute =
  ContractorContractorIdResourcesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContractorContractorIdResourcesRouteRoute,
  } as any)
const ContractorContractorIdResourcesForestCrewsRoute =
  ContractorContractorIdResourcesForestCrewsRouteImport.update({
    id: '/forest-crews',
    path: '/forest-crews',
    getParentRoute: () => ContractorContractorIdResourcesRouteRoute,
  } as any)
const ContractorContractorIdResourcesMachinesRoute =
  ContractorContractorIdResourcesMachinesRouteImport.update({
    id: '/machines',
    path: '/machines',
    getParentRoute: () => ContractorContractorIdResourcesRouteRoute,
  } as any)
const ContractorContractorIdSendSMSIndexRoute =
  ContractorContractorIdSendSMSIndexRouteImport.update({
    id: '/sendSMS/',
    path: '/sendSMS/',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ForestownerForestownerIdContactpreferencesIndexRoute =
  ForestownerForestownerIdContactpreferencesIndexRouteImport.update({
    id: '/contactpreferences/',
    path: '/contactpreferences/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdEditIndexRoute =
  ForestownerForestownerIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdPropertyIndexRoute =
  ForestownerForestownerIdPropertyIndexRouteImport.update({
    id: '/property/',
    path: '/property/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdPropertyAddRoute =
  ForestownerForestownerIdPropertyAddRouteImport.update({
    id: '/property/add',
    path: '/property/add',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdPropertySupplierNumberRoute =
  ForestownerForestownerIdPropertySupplierNumberRouteImport.update({
    id: '/property/supplier-number',
    path: '/property/supplier-number',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdSendSMSIndexRoute =
  ForestownerForestownerIdSendSMSIndexRouteImport.update({
    id: '/sendSMS/',
    path: '/sendSMS/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdShareownershipIndexRoute =
  ForestownerForestownerIdShareownershipIndexRouteImport.update({
    id: '/shareownership/',
    path: '/shareownership/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdIndexRoute =
  FrameworkForestownerForestownerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdAssignmentsRoute =
  FrameworkForestownerForestownerIdAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdDocumentsRoute =
  FrameworkForestownerForestownerIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdEconomyRoute =
  FrameworkForestownerForestownerIdEconomyRouteImport.update({
    id: '/economy',
    path: '/economy',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdFscRoute =
  FrameworkForestownerForestownerIdFscRouteImport.update({
    id: '/fsc',
    path: '/fsc',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdHistoryRoute =
  FrameworkForestownerForestownerIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdPropertyRoute =
  FrameworkForestownerForestownerIdPropertyRouteImport.update({
    id: '/property',
    path: '/property',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const FrameworkForestownerForestownerIdShareownershipRoute =
  FrameworkForestownerForestownerIdShareownershipRouteImport.update({
    id: '/shareownership',
    path: '/shareownership',
    getParentRoute: () => FrameworkForestownerForestownerIdRoute,
  } as any)
const TimberbuyerTimberBuyerIdContactpreferencesIndexRoute =
  TimberbuyerTimberBuyerIdContactpreferencesIndexRouteImport.update({
    id: '/contactpreferences/',
    path: '/contactpreferences/',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute =
  TimberbuyerTimberBuyerIdDeliveryLocationsIndexRouteImport.update({
    id: '/delivery-locations/',
    path: '/delivery-locations/',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const TimberbuyerTimberBuyerIdEditIndexRoute =
  TimberbuyerTimberBuyerIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsIndexRouteImport.update({
    id: '/sales-agreements/',
    path: '/sales-agreements/',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteImport.update({
    id: '/sales-agreements/$salesAgreementId',
    path: '/sales-agreements/$salesAgreementId',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsRegisterRouteImport.update({
    id: '/sales-agreements/register',
    path: '/sales-agreements/register',
    getParentRoute: () => TimberbuyerTimberBuyerIdRoute,
  } as any)
const ContractorContractorIdEmployeesEmployeeIdEditRoute =
  ContractorContractorIdEmployeesEmployeeIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => ContractorContractorIdEmployeesEmployeeIdRoute,
  } as any)
const ContractorContractorIdMachinesMachineIdEditRoute =
  ContractorContractorIdMachinesMachineIdEditRouteImport.update({
    id: '/machines/$machineId/edit',
    path: '/machines/$machineId/edit',
    getParentRoute: () => ContractorContractorIdRoute,
  } as any)
const ForestownerForestownerIdContactpreferencesExceptionsIndexRoute =
  ForestownerForestownerIdContactpreferencesExceptionsIndexRouteImport.update({
    id: '/contactpreferences/exceptions/',
    path: '/contactpreferences/exceptions/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdPropertyPropertyIdIndexRoute =
  ForestownerForestownerIdPropertyPropertyIdIndexRouteImport.update({
    id: '/property/$propertyId/',
    path: '/property/$propertyId/',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdPropertyProtectedAreaEditRoute =
  ForestownerForestownerIdPropertyProtectedAreaEditRouteImport.update({
    id: '/property/protected-area/edit',
    path: '/property/protected-area/edit',
    getParentRoute: () => ForestownerForestownerIdRoute,
  } as any)
const ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/',
      path: '/shareownership/editShareOwnership/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute,
    } as any,
  )
const ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute =
  ContractorContractorIdForestCrewsForestCrewIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => ContractorContractorIdForestCrewsForestCrewIdRoute,
  } as any)
const ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute =
  ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRouteImport.update(
    {
      id: '/property/$propertyId/protected-area/edit',
      path: '/property/$propertyId/protected-area/edit',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/endOwnership/',
      path: '/shareownership/editShareOwnership/endOwnership/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/forestOwnerAssociation/',
      path: '/shareownership/editShareOwnership/forestOwnerAssociation/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/partialTransfer/',
      path: '/shareownership/editShareOwnership/partialTransfer/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/partner/',
      path: '/shareownership/editShareOwnership/partner/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/terminateTransfer/',
      path: '/shareownership/editShareOwnership/terminateTransfer/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRouteImport.update(
    {
      id: '/edit/',
      path: '/edit/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRouteImport.update(
    {
      id: '/main-assortments/',
      path: '/main-assortments/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteImport.update(
    {
      id: '/price-periods/$pricePeriodId',
      path: '/price-periods/$pricePeriodId',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/partner/add/',
      path: '/shareownership/editShareOwnership/partner/add/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/partner/remove/',
      path: '/shareownership/editShareOwnership/partner/remove/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRouteImport.update(
    {
      id: '/price-periods/copy/',
      path: '/price-periods/copy/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRouteImport.update(
    {
      id: '/price-periods/create/',
      path: '/price-periods/create/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute,
    } as any,
  )
const ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute =
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRouteImport.update(
    {
      id: '/shareownership/editShareOwnership/partner/remove/summary/',
      path: '/shareownership/editShareOwnership/partner/remove/summary/',
      getParentRoute: () => ForestownerForestownerIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRouteImport.update(
    {
      id: '/assortment-categories/',
      path: '/assortment-categories/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute,
    } as any,
  )
const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRouteImport.update(
    {
      id: '/edit/',
      path: '/edit/',
      getParentRoute: () =>
        TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/catchAll': typeof CatchAllRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/assortment/search': typeof AssortmentSearchRoute
  '/assortment/types': typeof AssortmentTypesRoute
  '/contractor/$contractorId': typeof ContractorContractorIdRouteWithChildren
  '/contractor/register': typeof ContractorRegisterRoute
  '/contractor/search': typeof ContractorSearchRoute
  '/forestowner/$forestownerId': typeof ForestownerForestownerIdRouteWithChildren
  '/forestowner/auth-test': typeof ForestownerAuthTestRoute
  '/forestowner/register': typeof ForestownerRegisterRoute
  '/forestowner/search': typeof ForestownerSearchRoute
  '/framework/search': typeof FrameworkSearchRoute
  '/search/edit': typeof SearchEditRoute
  '/shareholder/register': typeof ShareholderRegisterRoute
  '/timberbuyer/$timberBuyerId': typeof TimberbuyerTimberBuyerIdRouteWithChildren
  '/timberbuyer/register': typeof TimberbuyerRegisterRoute
  '/timberbuyer/search': typeof TimberbuyerSearchRoute
  '/assortment/': typeof AssortmentIndexRoute
  '/bulk-sms/': typeof BulkSmsIndexRoute
  '/forestowner/': typeof ForestownerIndexRoute
  '/framework/': typeof FrameworkIndexRoute
  '/search/': typeof SearchIndexRoute
  '/timberbuyer/': typeof TimberbuyerIndexRoute
  '/contractor/$contractorId/resources': typeof ContractorContractorIdResourcesRouteRouteWithChildren
  '/contractor/$contractorId/documents': typeof ContractorContractorIdDocumentsRoute
  '/contractor/$contractorId/history': typeof ContractorContractorIdHistoryRoute
  '/forestowner/$forestownerId/assignments': typeof ForestownerForestownerIdAssignmentsRoute
  '/forestowner/$forestownerId/documents': typeof ForestownerForestownerIdDocumentsRoute
  '/forestowner/$forestownerId/economy': typeof ForestownerForestownerIdEconomyRoute
  '/forestowner/$forestownerId/fsc': typeof ForestownerForestownerIdFscRoute
  '/forestowner/$forestownerId/history': typeof ForestownerForestownerIdHistoryRoute
  '/framework/forestowner/$forestownerId': typeof FrameworkForestownerForestownerIdRouteWithChildren
  '/contractor/$contractorId/': typeof ContractorContractorIdIndexRoute
  '/forestowner/$forestownerId/': typeof ForestownerForestownerIdIndexRoute
  '/timberbuyer/$timberBuyerId/': typeof TimberbuyerTimberBuyerIdIndexRoute
  '/contractor/$contractorId/employees/$employeeId': typeof ContractorContractorIdEmployeesEmployeeIdRouteWithChildren
  '/contractor/$contractorId/employees/add': typeof ContractorContractorIdEmployeesAddRoute
  '/contractor/$contractorId/forest-crews/$forestCrewId': typeof ContractorContractorIdForestCrewsForestCrewIdRouteWithChildren
  '/contractor/$contractorId/forest-crews/add': typeof ContractorContractorIdForestCrewsAddRoute
  '/contractor/$contractorId/machines/add': typeof ContractorContractorIdMachinesAddRoute
  '/contractor/$contractorId/resources/forest-crews': typeof ContractorContractorIdResourcesForestCrewsRoute
  '/contractor/$contractorId/resources/machines': typeof ContractorContractorIdResourcesMachinesRoute
  '/forestowner/$forestownerId/property/add': typeof ForestownerForestownerIdPropertyAddRoute
  '/forestowner/$forestownerId/property/supplier-number': typeof ForestownerForestownerIdPropertySupplierNumberRoute
  '/framework/forestowner/$forestownerId/assignments': typeof FrameworkForestownerForestownerIdAssignmentsRoute
  '/framework/forestowner/$forestownerId/documents': typeof FrameworkForestownerForestownerIdDocumentsRoute
  '/framework/forestowner/$forestownerId/economy': typeof FrameworkForestownerForestownerIdEconomyRoute
  '/framework/forestowner/$forestownerId/fsc': typeof FrameworkForestownerForestownerIdFscRoute
  '/framework/forestowner/$forestownerId/history': typeof FrameworkForestownerForestownerIdHistoryRoute
  '/framework/forestowner/$forestownerId/property': typeof FrameworkForestownerForestownerIdPropertyRoute
  '/framework/forestowner/$forestownerId/shareownership': typeof FrameworkForestownerForestownerIdShareownershipRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteWithChildren
  '/timberbuyer/$timberBuyerId/sales-agreements/register': typeof TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute
  '/contractor/$contractorId/edit/': typeof ContractorContractorIdEditIndexRoute
  '/contractor/$contractorId/resources/': typeof ContractorContractorIdResourcesIndexRoute
  '/contractor/$contractorId/sendSMS/': typeof ContractorContractorIdSendSMSIndexRoute
  '/forestowner/$forestownerId/contactpreferences/': typeof ForestownerForestownerIdContactpreferencesIndexRoute
  '/forestowner/$forestownerId/edit/': typeof ForestownerForestownerIdEditIndexRoute
  '/forestowner/$forestownerId/property/': typeof ForestownerForestownerIdPropertyIndexRoute
  '/forestowner/$forestownerId/sendSMS/': typeof ForestownerForestownerIdSendSMSIndexRoute
  '/forestowner/$forestownerId/shareownership/': typeof ForestownerForestownerIdShareownershipIndexRoute
  '/framework/forestowner/$forestownerId/': typeof FrameworkForestownerForestownerIdIndexRoute
  '/timberbuyer/$timberBuyerId/contactpreferences/': typeof TimberbuyerTimberBuyerIdContactpreferencesIndexRoute
  '/timberbuyer/$timberBuyerId/delivery-locations/': typeof TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute
  '/timberbuyer/$timberBuyerId/edit/': typeof TimberbuyerTimberBuyerIdEditIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/': typeof TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute
  '/contractor/$contractorId/employees/$employeeId/edit': typeof ContractorContractorIdEmployeesEmployeeIdEditRoute
  '/contractor/$contractorId/machines/$machineId/edit': typeof ContractorContractorIdMachinesMachineIdEditRoute
  '/forestowner/$forestownerId/property/protected-area/edit': typeof ForestownerForestownerIdPropertyProtectedAreaEditRoute
  '/forestowner/$forestownerId/contactpreferences/exceptions/': typeof ForestownerForestownerIdContactpreferencesExceptionsIndexRoute
  '/forestowner/$forestownerId/property/$propertyId/': typeof ForestownerForestownerIdPropertyPropertyIdIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute
  '/forestowner/$forestownerId/property/$propertyId/protected-area/edit': typeof ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteWithChildren
  '/contractor/$contractorId/forest-crews/$forestCrewId/edit/': typeof ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/catchAll': typeof CatchAllRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/assortment/search': typeof AssortmentSearchRoute
  '/assortment/types': typeof AssortmentTypesRoute
  '/contractor/register': typeof ContractorRegisterRoute
  '/contractor/search': typeof ContractorSearchRoute
  '/forestowner/auth-test': typeof ForestownerAuthTestRoute
  '/forestowner/register': typeof ForestownerRegisterRoute
  '/forestowner/search': typeof ForestownerSearchRoute
  '/framework/search': typeof FrameworkSearchRoute
  '/search/edit': typeof SearchEditRoute
  '/shareholder/register': typeof ShareholderRegisterRoute
  '/timberbuyer/register': typeof TimberbuyerRegisterRoute
  '/timberbuyer/search': typeof TimberbuyerSearchRoute
  '/assortment': typeof AssortmentIndexRoute
  '/bulk-sms': typeof BulkSmsIndexRoute
  '/forestowner': typeof ForestownerIndexRoute
  '/framework': typeof FrameworkIndexRoute
  '/search': typeof SearchIndexRoute
  '/timberbuyer': typeof TimberbuyerIndexRoute
  '/contractor/$contractorId/documents': typeof ContractorContractorIdDocumentsRoute
  '/contractor/$contractorId/history': typeof ContractorContractorIdHistoryRoute
  '/forestowner/$forestownerId/assignments': typeof ForestownerForestownerIdAssignmentsRoute
  '/forestowner/$forestownerId/documents': typeof ForestownerForestownerIdDocumentsRoute
  '/forestowner/$forestownerId/economy': typeof ForestownerForestownerIdEconomyRoute
  '/forestowner/$forestownerId/fsc': typeof ForestownerForestownerIdFscRoute
  '/forestowner/$forestownerId/history': typeof ForestownerForestownerIdHistoryRoute
  '/contractor/$contractorId': typeof ContractorContractorIdIndexRoute
  '/forestowner/$forestownerId': typeof ForestownerForestownerIdIndexRoute
  '/timberbuyer/$timberBuyerId': typeof TimberbuyerTimberBuyerIdIndexRoute
  '/contractor/$contractorId/employees/$employeeId': typeof ContractorContractorIdEmployeesEmployeeIdRouteWithChildren
  '/contractor/$contractorId/employees/add': typeof ContractorContractorIdEmployeesAddRoute
  '/contractor/$contractorId/forest-crews/$forestCrewId': typeof ContractorContractorIdForestCrewsForestCrewIdRouteWithChildren
  '/contractor/$contractorId/forest-crews/add': typeof ContractorContractorIdForestCrewsAddRoute
  '/contractor/$contractorId/machines/add': typeof ContractorContractorIdMachinesAddRoute
  '/contractor/$contractorId/resources/forest-crews': typeof ContractorContractorIdResourcesForestCrewsRoute
  '/contractor/$contractorId/resources/machines': typeof ContractorContractorIdResourcesMachinesRoute
  '/forestowner/$forestownerId/property/add': typeof ForestownerForestownerIdPropertyAddRoute
  '/forestowner/$forestownerId/property/supplier-number': typeof ForestownerForestownerIdPropertySupplierNumberRoute
  '/framework/forestowner/$forestownerId/assignments': typeof FrameworkForestownerForestownerIdAssignmentsRoute
  '/framework/forestowner/$forestownerId/documents': typeof FrameworkForestownerForestownerIdDocumentsRoute
  '/framework/forestowner/$forestownerId/economy': typeof FrameworkForestownerForestownerIdEconomyRoute
  '/framework/forestowner/$forestownerId/fsc': typeof FrameworkForestownerForestownerIdFscRoute
  '/framework/forestowner/$forestownerId/history': typeof FrameworkForestownerForestownerIdHistoryRoute
  '/framework/forestowner/$forestownerId/property': typeof FrameworkForestownerForestownerIdPropertyRoute
  '/framework/forestowner/$forestownerId/shareownership': typeof FrameworkForestownerForestownerIdShareownershipRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/register': typeof TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute
  '/contractor/$contractorId/edit': typeof ContractorContractorIdEditIndexRoute
  '/contractor/$contractorId/resources': typeof ContractorContractorIdResourcesIndexRoute
  '/contractor/$contractorId/sendSMS': typeof ContractorContractorIdSendSMSIndexRoute
  '/forestowner/$forestownerId/contactpreferences': typeof ForestownerForestownerIdContactpreferencesIndexRoute
  '/forestowner/$forestownerId/edit': typeof ForestownerForestownerIdEditIndexRoute
  '/forestowner/$forestownerId/property': typeof ForestownerForestownerIdPropertyIndexRoute
  '/forestowner/$forestownerId/sendSMS': typeof ForestownerForestownerIdSendSMSIndexRoute
  '/forestowner/$forestownerId/shareownership': typeof ForestownerForestownerIdShareownershipIndexRoute
  '/framework/forestowner/$forestownerId': typeof FrameworkForestownerForestownerIdIndexRoute
  '/timberbuyer/$timberBuyerId/contactpreferences': typeof TimberbuyerTimberBuyerIdContactpreferencesIndexRoute
  '/timberbuyer/$timberBuyerId/delivery-locations': typeof TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute
  '/timberbuyer/$timberBuyerId/edit': typeof TimberbuyerTimberBuyerIdEditIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements': typeof TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute
  '/contractor/$contractorId/employees/$employeeId/edit': typeof ContractorContractorIdEmployeesEmployeeIdEditRoute
  '/contractor/$contractorId/machines/$machineId/edit': typeof ContractorContractorIdMachinesMachineIdEditRoute
  '/forestowner/$forestownerId/property/protected-area/edit': typeof ForestownerForestownerIdPropertyProtectedAreaEditRoute
  '/forestowner/$forestownerId/contactpreferences/exceptions': typeof ForestownerForestownerIdContactpreferencesExceptionsIndexRoute
  '/forestowner/$forestownerId/property/$propertyId': typeof ForestownerForestownerIdPropertyPropertyIdIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership': typeof ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute
  '/forestowner/$forestownerId/property/$propertyId/protected-area/edit': typeof ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute
  '/contractor/$contractorId/forest-crews/$forestCrewId/edit': typeof ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership': typeof ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation': typeof ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer': typeof ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/catchAll': typeof CatchAllRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/assortment/search': typeof AssortmentSearchRoute
  '/assortment/types': typeof AssortmentTypesRoute
  '/contractor/$contractorId': typeof ContractorContractorIdRouteWithChildren
  '/contractor/register': typeof ContractorRegisterRoute
  '/contractor/search': typeof ContractorSearchRoute
  '/forestowner/$forestownerId': typeof ForestownerForestownerIdRouteWithChildren
  '/forestowner/auth-test': typeof ForestownerAuthTestRoute
  '/forestowner/register': typeof ForestownerRegisterRoute
  '/forestowner/search': typeof ForestownerSearchRoute
  '/framework/search': typeof FrameworkSearchRoute
  '/search/edit': typeof SearchEditRoute
  '/shareholder/register': typeof ShareholderRegisterRoute
  '/timberbuyer/$timberBuyerId': typeof TimberbuyerTimberBuyerIdRouteWithChildren
  '/timberbuyer/register': typeof TimberbuyerRegisterRoute
  '/timberbuyer/search': typeof TimberbuyerSearchRoute
  '/assortment/': typeof AssortmentIndexRoute
  '/bulk-sms/': typeof BulkSmsIndexRoute
  '/forestowner/': typeof ForestownerIndexRoute
  '/framework/': typeof FrameworkIndexRoute
  '/search/': typeof SearchIndexRoute
  '/timberbuyer/': typeof TimberbuyerIndexRoute
  '/contractor/$contractorId/resources': typeof ContractorContractorIdResourcesRouteRouteWithChildren
  '/contractor/$contractorId/documents': typeof ContractorContractorIdDocumentsRoute
  '/contractor/$contractorId/history': typeof ContractorContractorIdHistoryRoute
  '/forestowner/$forestownerId/assignments': typeof ForestownerForestownerIdAssignmentsRoute
  '/forestowner/$forestownerId/documents': typeof ForestownerForestownerIdDocumentsRoute
  '/forestowner/$forestownerId/economy': typeof ForestownerForestownerIdEconomyRoute
  '/forestowner/$forestownerId/fsc': typeof ForestownerForestownerIdFscRoute
  '/forestowner/$forestownerId/history': typeof ForestownerForestownerIdHistoryRoute
  '/framework/forestowner/$forestownerId': typeof FrameworkForestownerForestownerIdRouteWithChildren
  '/contractor/$contractorId/': typeof ContractorContractorIdIndexRoute
  '/forestowner/$forestownerId/': typeof ForestownerForestownerIdIndexRoute
  '/timberbuyer/$timberBuyerId/': typeof TimberbuyerTimberBuyerIdIndexRoute
  '/contractor/$contractorId/employees/$employeeId': typeof ContractorContractorIdEmployeesEmployeeIdRouteWithChildren
  '/contractor/$contractorId/employees/add': typeof ContractorContractorIdEmployeesAddRoute
  '/contractor/$contractorId/forest-crews/$forestCrewId': typeof ContractorContractorIdForestCrewsForestCrewIdRouteWithChildren
  '/contractor/$contractorId/forest-crews/add': typeof ContractorContractorIdForestCrewsAddRoute
  '/contractor/$contractorId/machines/add': typeof ContractorContractorIdMachinesAddRoute
  '/contractor/$contractorId/resources/forest-crews': typeof ContractorContractorIdResourcesForestCrewsRoute
  '/contractor/$contractorId/resources/machines': typeof ContractorContractorIdResourcesMachinesRoute
  '/forestowner/$forestownerId/property/add': typeof ForestownerForestownerIdPropertyAddRoute
  '/forestowner/$forestownerId/property/supplier-number': typeof ForestownerForestownerIdPropertySupplierNumberRoute
  '/framework/forestowner/$forestownerId/assignments': typeof FrameworkForestownerForestownerIdAssignmentsRoute
  '/framework/forestowner/$forestownerId/documents': typeof FrameworkForestownerForestownerIdDocumentsRoute
  '/framework/forestowner/$forestownerId/economy': typeof FrameworkForestownerForestownerIdEconomyRoute
  '/framework/forestowner/$forestownerId/fsc': typeof FrameworkForestownerForestownerIdFscRoute
  '/framework/forestowner/$forestownerId/history': typeof FrameworkForestownerForestownerIdHistoryRoute
  '/framework/forestowner/$forestownerId/property': typeof FrameworkForestownerForestownerIdPropertyRoute
  '/framework/forestowner/$forestownerId/shareownership': typeof FrameworkForestownerForestownerIdShareownershipRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteWithChildren
  '/timberbuyer/$timberBuyerId/sales-agreements/register': typeof TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute
  '/contractor/$contractorId/edit/': typeof ContractorContractorIdEditIndexRoute
  '/contractor/$contractorId/resources/': typeof ContractorContractorIdResourcesIndexRoute
  '/contractor/$contractorId/sendSMS/': typeof ContractorContractorIdSendSMSIndexRoute
  '/forestowner/$forestownerId/contactpreferences/': typeof ForestownerForestownerIdContactpreferencesIndexRoute
  '/forestowner/$forestownerId/edit/': typeof ForestownerForestownerIdEditIndexRoute
  '/forestowner/$forestownerId/property/': typeof ForestownerForestownerIdPropertyIndexRoute
  '/forestowner/$forestownerId/sendSMS/': typeof ForestownerForestownerIdSendSMSIndexRoute
  '/forestowner/$forestownerId/shareownership/': typeof ForestownerForestownerIdShareownershipIndexRoute
  '/framework/forestowner/$forestownerId/': typeof FrameworkForestownerForestownerIdIndexRoute
  '/timberbuyer/$timberBuyerId/contactpreferences/': typeof TimberbuyerTimberBuyerIdContactpreferencesIndexRoute
  '/timberbuyer/$timberBuyerId/delivery-locations/': typeof TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute
  '/timberbuyer/$timberBuyerId/edit/': typeof TimberbuyerTimberBuyerIdEditIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/': typeof TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute
  '/contractor/$contractorId/employees/$employeeId/edit': typeof ContractorContractorIdEmployeesEmployeeIdEditRoute
  '/contractor/$contractorId/machines/$machineId/edit': typeof ContractorContractorIdMachinesMachineIdEditRoute
  '/forestowner/$forestownerId/property/protected-area/edit': typeof ForestownerForestownerIdPropertyProtectedAreaEditRoute
  '/forestowner/$forestownerId/contactpreferences/exceptions/': typeof ForestownerForestownerIdContactpreferencesExceptionsIndexRoute
  '/forestowner/$forestownerId/property/$propertyId/': typeof ForestownerForestownerIdPropertyPropertyIdIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute
  '/forestowner/$forestownerId/property/$propertyId/protected-area/edit': typeof ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteWithChildren
  '/contractor/$contractorId/forest-crews/$forestCrewId/edit/': typeof ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/': typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/': typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/catchAll'
    | '/unauthorized'
    | '/assortment/search'
    | '/assortment/types'
    | '/contractor/$contractorId'
    | '/contractor/register'
    | '/contractor/search'
    | '/forestowner/$forestownerId'
    | '/forestowner/auth-test'
    | '/forestowner/register'
    | '/forestowner/search'
    | '/framework/search'
    | '/search/edit'
    | '/shareholder/register'
    | '/timberbuyer/$timberBuyerId'
    | '/timberbuyer/register'
    | '/timberbuyer/search'
    | '/assortment/'
    | '/bulk-sms/'
    | '/forestowner/'
    | '/framework/'
    | '/search/'
    | '/timberbuyer/'
    | '/contractor/$contractorId/resources'
    | '/contractor/$contractorId/documents'
    | '/contractor/$contractorId/history'
    | '/forestowner/$forestownerId/assignments'
    | '/forestowner/$forestownerId/documents'
    | '/forestowner/$forestownerId/economy'
    | '/forestowner/$forestownerId/fsc'
    | '/forestowner/$forestownerId/history'
    | '/framework/forestowner/$forestownerId'
    | '/contractor/$contractorId/'
    | '/forestowner/$forestownerId/'
    | '/timberbuyer/$timberBuyerId/'
    | '/contractor/$contractorId/employees/$employeeId'
    | '/contractor/$contractorId/employees/add'
    | '/contractor/$contractorId/forest-crews/$forestCrewId'
    | '/contractor/$contractorId/forest-crews/add'
    | '/contractor/$contractorId/machines/add'
    | '/contractor/$contractorId/resources/forest-crews'
    | '/contractor/$contractorId/resources/machines'
    | '/forestowner/$forestownerId/property/add'
    | '/forestowner/$forestownerId/property/supplier-number'
    | '/framework/forestowner/$forestownerId/assignments'
    | '/framework/forestowner/$forestownerId/documents'
    | '/framework/forestowner/$forestownerId/economy'
    | '/framework/forestowner/$forestownerId/fsc'
    | '/framework/forestowner/$forestownerId/history'
    | '/framework/forestowner/$forestownerId/property'
    | '/framework/forestowner/$forestownerId/shareownership'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId'
    | '/timberbuyer/$timberBuyerId/sales-agreements/register'
    | '/contractor/$contractorId/edit/'
    | '/contractor/$contractorId/resources/'
    | '/contractor/$contractorId/sendSMS/'
    | '/forestowner/$forestownerId/contactpreferences/'
    | '/forestowner/$forestownerId/edit/'
    | '/forestowner/$forestownerId/property/'
    | '/forestowner/$forestownerId/sendSMS/'
    | '/forestowner/$forestownerId/shareownership/'
    | '/framework/forestowner/$forestownerId/'
    | '/timberbuyer/$timberBuyerId/contactpreferences/'
    | '/timberbuyer/$timberBuyerId/delivery-locations/'
    | '/timberbuyer/$timberBuyerId/edit/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/'
    | '/contractor/$contractorId/employees/$employeeId/edit'
    | '/contractor/$contractorId/machines/$machineId/edit'
    | '/forestowner/$forestownerId/property/protected-area/edit'
    | '/forestowner/$forestownerId/contactpreferences/exceptions/'
    | '/forestowner/$forestownerId/property/$propertyId/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/'
    | '/forestowner/$forestownerId/property/$propertyId/protected-area/edit'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId'
    | '/contractor/$contractorId/forest-crews/$forestCrewId/edit/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/catchAll'
    | '/unauthorized'
    | '/assortment/search'
    | '/assortment/types'
    | '/contractor/register'
    | '/contractor/search'
    | '/forestowner/auth-test'
    | '/forestowner/register'
    | '/forestowner/search'
    | '/framework/search'
    | '/search/edit'
    | '/shareholder/register'
    | '/timberbuyer/register'
    | '/timberbuyer/search'
    | '/assortment'
    | '/bulk-sms'
    | '/forestowner'
    | '/framework'
    | '/search'
    | '/timberbuyer'
    | '/contractor/$contractorId/documents'
    | '/contractor/$contractorId/history'
    | '/forestowner/$forestownerId/assignments'
    | '/forestowner/$forestownerId/documents'
    | '/forestowner/$forestownerId/economy'
    | '/forestowner/$forestownerId/fsc'
    | '/forestowner/$forestownerId/history'
    | '/contractor/$contractorId'
    | '/forestowner/$forestownerId'
    | '/timberbuyer/$timberBuyerId'
    | '/contractor/$contractorId/employees/$employeeId'
    | '/contractor/$contractorId/employees/add'
    | '/contractor/$contractorId/forest-crews/$forestCrewId'
    | '/contractor/$contractorId/forest-crews/add'
    | '/contractor/$contractorId/machines/add'
    | '/contractor/$contractorId/resources/forest-crews'
    | '/contractor/$contractorId/resources/machines'
    | '/forestowner/$forestownerId/property/add'
    | '/forestowner/$forestownerId/property/supplier-number'
    | '/framework/forestowner/$forestownerId/assignments'
    | '/framework/forestowner/$forestownerId/documents'
    | '/framework/forestowner/$forestownerId/economy'
    | '/framework/forestowner/$forestownerId/fsc'
    | '/framework/forestowner/$forestownerId/history'
    | '/framework/forestowner/$forestownerId/property'
    | '/framework/forestowner/$forestownerId/shareownership'
    | '/timberbuyer/$timberBuyerId/sales-agreements/register'
    | '/contractor/$contractorId/edit'
    | '/contractor/$contractorId/resources'
    | '/contractor/$contractorId/sendSMS'
    | '/forestowner/$forestownerId/contactpreferences'
    | '/forestowner/$forestownerId/edit'
    | '/forestowner/$forestownerId/property'
    | '/forestowner/$forestownerId/sendSMS'
    | '/forestowner/$forestownerId/shareownership'
    | '/framework/forestowner/$forestownerId'
    | '/timberbuyer/$timberBuyerId/contactpreferences'
    | '/timberbuyer/$timberBuyerId/delivery-locations'
    | '/timberbuyer/$timberBuyerId/edit'
    | '/timberbuyer/$timberBuyerId/sales-agreements'
    | '/contractor/$contractorId/employees/$employeeId/edit'
    | '/contractor/$contractorId/machines/$machineId/edit'
    | '/forestowner/$forestownerId/property/protected-area/edit'
    | '/forestowner/$forestownerId/contactpreferences/exceptions'
    | '/forestowner/$forestownerId/property/$propertyId'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId'
    | '/forestowner/$forestownerId/property/$propertyId/protected-area/edit'
    | '/contractor/$contractorId/forest-crews/$forestCrewId/edit'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit'
  id:
    | '__root__'
    | '/'
    | '/catchAll'
    | '/unauthorized'
    | '/assortment/search'
    | '/assortment/types'
    | '/contractor/$contractorId'
    | '/contractor/register'
    | '/contractor/search'
    | '/forestowner/$forestownerId'
    | '/forestowner/auth-test'
    | '/forestowner/register'
    | '/forestowner/search'
    | '/framework/search'
    | '/search/edit'
    | '/shareholder/register'
    | '/timberbuyer/$timberBuyerId'
    | '/timberbuyer/register'
    | '/timberbuyer/search'
    | '/assortment/'
    | '/bulk-sms/'
    | '/forestowner/'
    | '/framework/'
    | '/search/'
    | '/timberbuyer/'
    | '/contractor/$contractorId/resources'
    | '/contractor/$contractorId/documents'
    | '/contractor/$contractorId/history'
    | '/forestowner/$forestownerId/assignments'
    | '/forestowner/$forestownerId/documents'
    | '/forestowner/$forestownerId/economy'
    | '/forestowner/$forestownerId/fsc'
    | '/forestowner/$forestownerId/history'
    | '/framework/forestowner/$forestownerId'
    | '/contractor/$contractorId/'
    | '/forestowner/$forestownerId/'
    | '/timberbuyer/$timberBuyerId/'
    | '/contractor/$contractorId/employees/$employeeId'
    | '/contractor/$contractorId/employees/add'
    | '/contractor/$contractorId/forest-crews/$forestCrewId'
    | '/contractor/$contractorId/forest-crews/add'
    | '/contractor/$contractorId/machines/add'
    | '/contractor/$contractorId/resources/forest-crews'
    | '/contractor/$contractorId/resources/machines'
    | '/forestowner/$forestownerId/property/add'
    | '/forestowner/$forestownerId/property/supplier-number'
    | '/framework/forestowner/$forestownerId/assignments'
    | '/framework/forestowner/$forestownerId/documents'
    | '/framework/forestowner/$forestownerId/economy'
    | '/framework/forestowner/$forestownerId/fsc'
    | '/framework/forestowner/$forestownerId/history'
    | '/framework/forestowner/$forestownerId/property'
    | '/framework/forestowner/$forestownerId/shareownership'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId'
    | '/timberbuyer/$timberBuyerId/sales-agreements/register'
    | '/contractor/$contractorId/edit/'
    | '/contractor/$contractorId/resources/'
    | '/contractor/$contractorId/sendSMS/'
    | '/forestowner/$forestownerId/contactpreferences/'
    | '/forestowner/$forestownerId/edit/'
    | '/forestowner/$forestownerId/property/'
    | '/forestowner/$forestownerId/sendSMS/'
    | '/forestowner/$forestownerId/shareownership/'
    | '/framework/forestowner/$forestownerId/'
    | '/timberbuyer/$timberBuyerId/contactpreferences/'
    | '/timberbuyer/$timberBuyerId/delivery-locations/'
    | '/timberbuyer/$timberBuyerId/edit/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/'
    | '/contractor/$contractorId/employees/$employeeId/edit'
    | '/contractor/$contractorId/machines/$machineId/edit'
    | '/forestowner/$forestownerId/property/protected-area/edit'
    | '/forestowner/$forestownerId/contactpreferences/exceptions/'
    | '/forestowner/$forestownerId/property/$propertyId/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/'
    | '/forestowner/$forestownerId/property/$propertyId/protected-area/edit'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId'
    | '/contractor/$contractorId/forest-crews/$forestCrewId/edit/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/'
    | '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/'
    | '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CatchAllRoute: typeof CatchAllRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  AssortmentSearchRoute: typeof AssortmentSearchRoute
  AssortmentTypesRoute: typeof AssortmentTypesRoute
  ContractorContractorIdRoute: typeof ContractorContractorIdRouteWithChildren
  ContractorRegisterRoute: typeof ContractorRegisterRoute
  ContractorSearchRoute: typeof ContractorSearchRoute
  ForestownerForestownerIdRoute: typeof ForestownerForestownerIdRouteWithChildren
  ForestownerAuthTestRoute: typeof ForestownerAuthTestRoute
  ForestownerRegisterRoute: typeof ForestownerRegisterRoute
  ForestownerSearchRoute: typeof ForestownerSearchRoute
  FrameworkSearchRoute: typeof FrameworkSearchRoute
  SearchEditRoute: typeof SearchEditRoute
  ShareholderRegisterRoute: typeof ShareholderRegisterRoute
  TimberbuyerTimberBuyerIdRoute: typeof TimberbuyerTimberBuyerIdRouteWithChildren
  TimberbuyerRegisterRoute: typeof TimberbuyerRegisterRoute
  TimberbuyerSearchRoute: typeof TimberbuyerSearchRoute
  AssortmentIndexRoute: typeof AssortmentIndexRoute
  BulkSmsIndexRoute: typeof BulkSmsIndexRoute
  ForestownerIndexRoute: typeof ForestownerIndexRoute
  FrameworkIndexRoute: typeof FrameworkIndexRoute
  SearchIndexRoute: typeof SearchIndexRoute
  TimberbuyerIndexRoute: typeof TimberbuyerIndexRoute
  FrameworkForestownerForestownerIdRoute: typeof FrameworkForestownerForestownerIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catchAll': {
      id: '/catchAll'
      path: '/catchAll'
      fullPath: '/catchAll'
      preLoaderRoute: typeof CatchAllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assortment/': {
      id: '/assortment/'
      path: '/assortment'
      fullPath: '/assortment/'
      preLoaderRoute: typeof AssortmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assortment/search': {
      id: '/assortment/search'
      path: '/assortment/search'
      fullPath: '/assortment/search'
      preLoaderRoute: typeof AssortmentSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assortment/types': {
      id: '/assortment/types'
      path: '/assortment/types'
      fullPath: '/assortment/types'
      preLoaderRoute: typeof AssortmentTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk-sms/': {
      id: '/bulk-sms/'
      path: '/bulk-sms'
      fullPath: '/bulk-sms/'
      preLoaderRoute: typeof BulkSmsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractor/$contractorId': {
      id: '/contractor/$contractorId'
      path: '/contractor/$contractorId'
      fullPath: '/contractor/$contractorId'
      preLoaderRoute: typeof ContractorContractorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractor/register': {
      id: '/contractor/register'
      path: '/contractor/register'
      fullPath: '/contractor/register'
      preLoaderRoute: typeof ContractorRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractor/search': {
      id: '/contractor/search'
      path: '/contractor/search'
      fullPath: '/contractor/search'
      preLoaderRoute: typeof ContractorSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forestowner/': {
      id: '/forestowner/'
      path: '/forestowner'
      fullPath: '/forestowner/'
      preLoaderRoute: typeof ForestownerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forestowner/$forestownerId': {
      id: '/forestowner/$forestownerId'
      path: '/forestowner/$forestownerId'
      fullPath: '/forestowner/$forestownerId'
      preLoaderRoute: typeof ForestownerForestownerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forestowner/auth-test': {
      id: '/forestowner/auth-test'
      path: '/forestowner/auth-test'
      fullPath: '/forestowner/auth-test'
      preLoaderRoute: typeof ForestownerAuthTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forestowner/register': {
      id: '/forestowner/register'
      path: '/forestowner/register'
      fullPath: '/forestowner/register'
      preLoaderRoute: typeof ForestownerRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forestowner/search': {
      id: '/forestowner/search'
      path: '/forestowner/search'
      fullPath: '/forestowner/search'
      preLoaderRoute: typeof ForestownerSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/framework/': {
      id: '/framework/'
      path: '/framework'
      fullPath: '/framework/'
      preLoaderRoute: typeof FrameworkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/framework/search': {
      id: '/framework/search'
      path: '/framework/search'
      fullPath: '/framework/search'
      preLoaderRoute: typeof FrameworkSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search/': {
      id: '/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof SearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search/edit': {
      id: '/search/edit'
      path: '/search/edit'
      fullPath: '/search/edit'
      preLoaderRoute: typeof SearchEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shareholder/register': {
      id: '/shareholder/register'
      path: '/shareholder/register'
      fullPath: '/shareholder/register'
      preLoaderRoute: typeof ShareholderRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timberbuyer/': {
      id: '/timberbuyer/'
      path: '/timberbuyer'
      fullPath: '/timberbuyer/'
      preLoaderRoute: typeof TimberbuyerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timberbuyer/$timberBuyerId': {
      id: '/timberbuyer/$timberBuyerId'
      path: '/timberbuyer/$timberBuyerId'
      fullPath: '/timberbuyer/$timberBuyerId'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timberbuyer/register': {
      id: '/timberbuyer/register'
      path: '/timberbuyer/register'
      fullPath: '/timberbuyer/register'
      preLoaderRoute: typeof TimberbuyerRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timberbuyer/search': {
      id: '/timberbuyer/search'
      path: '/timberbuyer/search'
      fullPath: '/timberbuyer/search'
      preLoaderRoute: typeof TimberbuyerSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractor/$contractorId/': {
      id: '/contractor/$contractorId/'
      path: '/'
      fullPath: '/contractor/$contractorId/'
      preLoaderRoute: typeof ContractorContractorIdIndexRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/documents': {
      id: '/contractor/$contractorId/documents'
      path: '/documents'
      fullPath: '/contractor/$contractorId/documents'
      preLoaderRoute: typeof ContractorContractorIdDocumentsRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/history': {
      id: '/contractor/$contractorId/history'
      path: '/history'
      fullPath: '/contractor/$contractorId/history'
      preLoaderRoute: typeof ContractorContractorIdHistoryRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/resources': {
      id: '/contractor/$contractorId/resources'
      path: '/resources'
      fullPath: '/contractor/$contractorId/resources'
      preLoaderRoute: typeof ContractorContractorIdResourcesRouteRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/forestowner/$forestownerId/': {
      id: '/forestowner/$forestownerId/'
      path: '/'
      fullPath: '/forestowner/$forestownerId/'
      preLoaderRoute: typeof ForestownerForestownerIdIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/assignments': {
      id: '/forestowner/$forestownerId/assignments'
      path: '/assignments'
      fullPath: '/forestowner/$forestownerId/assignments'
      preLoaderRoute: typeof ForestownerForestownerIdAssignmentsRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/documents': {
      id: '/forestowner/$forestownerId/documents'
      path: '/documents'
      fullPath: '/forestowner/$forestownerId/documents'
      preLoaderRoute: typeof ForestownerForestownerIdDocumentsRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/economy': {
      id: '/forestowner/$forestownerId/economy'
      path: '/economy'
      fullPath: '/forestowner/$forestownerId/economy'
      preLoaderRoute: typeof ForestownerForestownerIdEconomyRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/fsc': {
      id: '/forestowner/$forestownerId/fsc'
      path: '/fsc'
      fullPath: '/forestowner/$forestownerId/fsc'
      preLoaderRoute: typeof ForestownerForestownerIdFscRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/history': {
      id: '/forestowner/$forestownerId/history'
      path: '/history'
      fullPath: '/forestowner/$forestownerId/history'
      preLoaderRoute: typeof ForestownerForestownerIdHistoryRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId': {
      id: '/framework/forestowner/$forestownerId'
      path: '/framework/forestowner/$forestownerId'
      fullPath: '/framework/forestowner/$forestownerId'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timberbuyer/$timberBuyerId/': {
      id: '/timberbuyer/$timberBuyerId/'
      path: '/'
      fullPath: '/timberbuyer/$timberBuyerId/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/contractor/$contractorId/edit/': {
      id: '/contractor/$contractorId/edit/'
      path: '/edit'
      fullPath: '/contractor/$contractorId/edit/'
      preLoaderRoute: typeof ContractorContractorIdEditIndexRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/employees/$employeeId': {
      id: '/contractor/$contractorId/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/contractor/$contractorId/employees/$employeeId'
      preLoaderRoute: typeof ContractorContractorIdEmployeesEmployeeIdRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/employees/add': {
      id: '/contractor/$contractorId/employees/add'
      path: '/employees/add'
      fullPath: '/contractor/$contractorId/employees/add'
      preLoaderRoute: typeof ContractorContractorIdEmployeesAddRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/forest-crews/$forestCrewId': {
      id: '/contractor/$contractorId/forest-crews/$forestCrewId'
      path: '/forest-crews/$forestCrewId'
      fullPath: '/contractor/$contractorId/forest-crews/$forestCrewId'
      preLoaderRoute: typeof ContractorContractorIdForestCrewsForestCrewIdRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/forest-crews/add': {
      id: '/contractor/$contractorId/forest-crews/add'
      path: '/forest-crews/add'
      fullPath: '/contractor/$contractorId/forest-crews/add'
      preLoaderRoute: typeof ContractorContractorIdForestCrewsAddRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/machines/add': {
      id: '/contractor/$contractorId/machines/add'
      path: '/machines/add'
      fullPath: '/contractor/$contractorId/machines/add'
      preLoaderRoute: typeof ContractorContractorIdMachinesAddRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/contractor/$contractorId/resources/': {
      id: '/contractor/$contractorId/resources/'
      path: '/'
      fullPath: '/contractor/$contractorId/resources/'
      preLoaderRoute: typeof ContractorContractorIdResourcesIndexRouteImport
      parentRoute: typeof ContractorContractorIdResourcesRouteRoute
    }
    '/contractor/$contractorId/resources/forest-crews': {
      id: '/contractor/$contractorId/resources/forest-crews'
      path: '/forest-crews'
      fullPath: '/contractor/$contractorId/resources/forest-crews'
      preLoaderRoute: typeof ContractorContractorIdResourcesForestCrewsRouteImport
      parentRoute: typeof ContractorContractorIdResourcesRouteRoute
    }
    '/contractor/$contractorId/resources/machines': {
      id: '/contractor/$contractorId/resources/machines'
      path: '/machines'
      fullPath: '/contractor/$contractorId/resources/machines'
      preLoaderRoute: typeof ContractorContractorIdResourcesMachinesRouteImport
      parentRoute: typeof ContractorContractorIdResourcesRouteRoute
    }
    '/contractor/$contractorId/sendSMS/': {
      id: '/contractor/$contractorId/sendSMS/'
      path: '/sendSMS'
      fullPath: '/contractor/$contractorId/sendSMS/'
      preLoaderRoute: typeof ContractorContractorIdSendSMSIndexRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/forestowner/$forestownerId/contactpreferences/': {
      id: '/forestowner/$forestownerId/contactpreferences/'
      path: '/contactpreferences'
      fullPath: '/forestowner/$forestownerId/contactpreferences/'
      preLoaderRoute: typeof ForestownerForestownerIdContactpreferencesIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/edit/': {
      id: '/forestowner/$forestownerId/edit/'
      path: '/edit'
      fullPath: '/forestowner/$forestownerId/edit/'
      preLoaderRoute: typeof ForestownerForestownerIdEditIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/property/': {
      id: '/forestowner/$forestownerId/property/'
      path: '/property'
      fullPath: '/forestowner/$forestownerId/property/'
      preLoaderRoute: typeof ForestownerForestownerIdPropertyIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/property/add': {
      id: '/forestowner/$forestownerId/property/add'
      path: '/property/add'
      fullPath: '/forestowner/$forestownerId/property/add'
      preLoaderRoute: typeof ForestownerForestownerIdPropertyAddRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/property/supplier-number': {
      id: '/forestowner/$forestownerId/property/supplier-number'
      path: '/property/supplier-number'
      fullPath: '/forestowner/$forestownerId/property/supplier-number'
      preLoaderRoute: typeof ForestownerForestownerIdPropertySupplierNumberRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/sendSMS/': {
      id: '/forestowner/$forestownerId/sendSMS/'
      path: '/sendSMS'
      fullPath: '/forestowner/$forestownerId/sendSMS/'
      preLoaderRoute: typeof ForestownerForestownerIdSendSMSIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/': {
      id: '/forestowner/$forestownerId/shareownership/'
      path: '/shareownership'
      fullPath: '/forestowner/$forestownerId/shareownership/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/': {
      id: '/framework/forestowner/$forestownerId/'
      path: '/'
      fullPath: '/framework/forestowner/$forestownerId/'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdIndexRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/assignments': {
      id: '/framework/forestowner/$forestownerId/assignments'
      path: '/assignments'
      fullPath: '/framework/forestowner/$forestownerId/assignments'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdAssignmentsRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/documents': {
      id: '/framework/forestowner/$forestownerId/documents'
      path: '/documents'
      fullPath: '/framework/forestowner/$forestownerId/documents'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdDocumentsRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/economy': {
      id: '/framework/forestowner/$forestownerId/economy'
      path: '/economy'
      fullPath: '/framework/forestowner/$forestownerId/economy'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdEconomyRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/fsc': {
      id: '/framework/forestowner/$forestownerId/fsc'
      path: '/fsc'
      fullPath: '/framework/forestowner/$forestownerId/fsc'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdFscRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/history': {
      id: '/framework/forestowner/$forestownerId/history'
      path: '/history'
      fullPath: '/framework/forestowner/$forestownerId/history'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdHistoryRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/property': {
      id: '/framework/forestowner/$forestownerId/property'
      path: '/property'
      fullPath: '/framework/forestowner/$forestownerId/property'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdPropertyRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/framework/forestowner/$forestownerId/shareownership': {
      id: '/framework/forestowner/$forestownerId/shareownership'
      path: '/shareownership'
      fullPath: '/framework/forestowner/$forestownerId/shareownership'
      preLoaderRoute: typeof FrameworkForestownerForestownerIdShareownershipRouteImport
      parentRoute: typeof FrameworkForestownerForestownerIdRoute
    }
    '/timberbuyer/$timberBuyerId/contactpreferences/': {
      id: '/timberbuyer/$timberBuyerId/contactpreferences/'
      path: '/contactpreferences'
      fullPath: '/timberbuyer/$timberBuyerId/contactpreferences/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdContactpreferencesIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/timberbuyer/$timberBuyerId/delivery-locations/': {
      id: '/timberbuyer/$timberBuyerId/delivery-locations/'
      path: '/delivery-locations'
      fullPath: '/timberbuyer/$timberBuyerId/delivery-locations/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdDeliveryLocationsIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/timberbuyer/$timberBuyerId/edit/': {
      id: '/timberbuyer/$timberBuyerId/edit/'
      path: '/edit'
      fullPath: '/timberbuyer/$timberBuyerId/edit/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdEditIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/'
      path: '/sales-agreements'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId'
      path: '/sales-agreements/$salesAgreementId'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/register': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/register'
      path: '/sales-agreements/register'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/register'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsRegisterRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdRoute
    }
    '/contractor/$contractorId/employees/$employeeId/edit': {
      id: '/contractor/$contractorId/employees/$employeeId/edit'
      path: '/edit'
      fullPath: '/contractor/$contractorId/employees/$employeeId/edit'
      preLoaderRoute: typeof ContractorContractorIdEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof ContractorContractorIdEmployeesEmployeeIdRoute
    }
    '/contractor/$contractorId/machines/$machineId/edit': {
      id: '/contractor/$contractorId/machines/$machineId/edit'
      path: '/machines/$machineId/edit'
      fullPath: '/contractor/$contractorId/machines/$machineId/edit'
      preLoaderRoute: typeof ContractorContractorIdMachinesMachineIdEditRouteImport
      parentRoute: typeof ContractorContractorIdRoute
    }
    '/forestowner/$forestownerId/contactpreferences/exceptions/': {
      id: '/forestowner/$forestownerId/contactpreferences/exceptions/'
      path: '/contactpreferences/exceptions'
      fullPath: '/forestowner/$forestownerId/contactpreferences/exceptions/'
      preLoaderRoute: typeof ForestownerForestownerIdContactpreferencesExceptionsIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/property/$propertyId/': {
      id: '/forestowner/$forestownerId/property/$propertyId/'
      path: '/property/$propertyId'
      fullPath: '/forestowner/$forestownerId/property/$propertyId/'
      preLoaderRoute: typeof ForestownerForestownerIdPropertyPropertyIdIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/property/protected-area/edit': {
      id: '/forestowner/$forestownerId/property/protected-area/edit'
      path: '/property/protected-area/edit'
      fullPath: '/forestowner/$forestownerId/property/protected-area/edit'
      preLoaderRoute: typeof ForestownerForestownerIdPropertyProtectedAreaEditRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/'
      path: '/shareownership/editShareOwnership'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/'
      path: '/'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute
    }
    '/contractor/$contractorId/forest-crews/$forestCrewId/edit/': {
      id: '/contractor/$contractorId/forest-crews/$forestCrewId/edit/'
      path: '/edit'
      fullPath: '/contractor/$contractorId/forest-crews/$forestCrewId/edit/'
      preLoaderRoute: typeof ContractorContractorIdForestCrewsForestCrewIdEditIndexRouteImport
      parentRoute: typeof ContractorContractorIdForestCrewsForestCrewIdRoute
    }
    '/forestowner/$forestownerId/property/$propertyId/protected-area/edit': {
      id: '/forestowner/$forestownerId/property/$propertyId/protected-area/edit'
      path: '/property/$propertyId/protected-area/edit'
      fullPath: '/forestowner/$forestownerId/property/$propertyId/protected-area/edit'
      preLoaderRoute: typeof ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/'
      path: '/shareownership/editShareOwnership/endOwnership'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/endOwnership/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/'
      path: '/shareownership/editShareOwnership/forestOwnerAssociation'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/'
      path: '/shareownership/editShareOwnership/partialTransfer'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/'
      path: '/shareownership/editShareOwnership/partner'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/'
      path: '/shareownership/editShareOwnership/terminateTransfer'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/'
      path: '/edit'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/'
      path: '/main-assortments'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId'
      path: '/price-periods/$pricePeriodId'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/'
      path: '/shareownership/editShareOwnership/partner/add'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/'
      path: '/shareownership/editShareOwnership/partner/remove'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/'
      path: '/'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/'
      path: '/price-periods/copy'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/'
      path: '/price-periods/create'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/create/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute
    }
    '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/': {
      id: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/'
      path: '/shareownership/editShareOwnership/partner/remove/summary'
      fullPath: '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/summary/'
      preLoaderRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRouteImport
      parentRoute: typeof ForestownerForestownerIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/'
      path: '/assortment-categories'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute
    }
    '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/': {
      id: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/'
      path: '/edit'
      fullPath: '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/edit/'
      preLoaderRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRouteImport
      parentRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute
    }
  }
}

interface ContractorContractorIdResourcesRouteRouteChildren {
  ContractorContractorIdResourcesForestCrewsRoute: typeof ContractorContractorIdResourcesForestCrewsRoute
  ContractorContractorIdResourcesMachinesRoute: typeof ContractorContractorIdResourcesMachinesRoute
  ContractorContractorIdResourcesIndexRoute: typeof ContractorContractorIdResourcesIndexRoute
}

const ContractorContractorIdResourcesRouteRouteChildren: ContractorContractorIdResourcesRouteRouteChildren =
  {
    ContractorContractorIdResourcesForestCrewsRoute:
      ContractorContractorIdResourcesForestCrewsRoute,
    ContractorContractorIdResourcesMachinesRoute:
      ContractorContractorIdResourcesMachinesRoute,
    ContractorContractorIdResourcesIndexRoute:
      ContractorContractorIdResourcesIndexRoute,
  }

const ContractorContractorIdResourcesRouteRouteWithChildren =
  ContractorContractorIdResourcesRouteRoute._addFileChildren(
    ContractorContractorIdResourcesRouteRouteChildren,
  )

interface ContractorContractorIdEmployeesEmployeeIdRouteChildren {
  ContractorContractorIdEmployeesEmployeeIdEditRoute: typeof ContractorContractorIdEmployeesEmployeeIdEditRoute
}

const ContractorContractorIdEmployeesEmployeeIdRouteChildren: ContractorContractorIdEmployeesEmployeeIdRouteChildren =
  {
    ContractorContractorIdEmployeesEmployeeIdEditRoute:
      ContractorContractorIdEmployeesEmployeeIdEditRoute,
  }

const ContractorContractorIdEmployeesEmployeeIdRouteWithChildren =
  ContractorContractorIdEmployeesEmployeeIdRoute._addFileChildren(
    ContractorContractorIdEmployeesEmployeeIdRouteChildren,
  )

interface ContractorContractorIdForestCrewsForestCrewIdRouteChildren {
  ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute: typeof ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute
}

const ContractorContractorIdForestCrewsForestCrewIdRouteChildren: ContractorContractorIdForestCrewsForestCrewIdRouteChildren =
  {
    ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute:
      ContractorContractorIdForestCrewsForestCrewIdEditIndexRoute,
  }

const ContractorContractorIdForestCrewsForestCrewIdRouteWithChildren =
  ContractorContractorIdForestCrewsForestCrewIdRoute._addFileChildren(
    ContractorContractorIdForestCrewsForestCrewIdRouteChildren,
  )

interface ContractorContractorIdRouteChildren {
  ContractorContractorIdResourcesRouteRoute: typeof ContractorContractorIdResourcesRouteRouteWithChildren
  ContractorContractorIdDocumentsRoute: typeof ContractorContractorIdDocumentsRoute
  ContractorContractorIdHistoryRoute: typeof ContractorContractorIdHistoryRoute
  ContractorContractorIdIndexRoute: typeof ContractorContractorIdIndexRoute
  ContractorContractorIdEmployeesEmployeeIdRoute: typeof ContractorContractorIdEmployeesEmployeeIdRouteWithChildren
  ContractorContractorIdEmployeesAddRoute: typeof ContractorContractorIdEmployeesAddRoute
  ContractorContractorIdForestCrewsForestCrewIdRoute: typeof ContractorContractorIdForestCrewsForestCrewIdRouteWithChildren
  ContractorContractorIdForestCrewsAddRoute: typeof ContractorContractorIdForestCrewsAddRoute
  ContractorContractorIdMachinesAddRoute: typeof ContractorContractorIdMachinesAddRoute
  ContractorContractorIdEditIndexRoute: typeof ContractorContractorIdEditIndexRoute
  ContractorContractorIdSendSMSIndexRoute: typeof ContractorContractorIdSendSMSIndexRoute
  ContractorContractorIdMachinesMachineIdEditRoute: typeof ContractorContractorIdMachinesMachineIdEditRoute
}

const ContractorContractorIdRouteChildren: ContractorContractorIdRouteChildren =
  {
    ContractorContractorIdResourcesRouteRoute:
      ContractorContractorIdResourcesRouteRouteWithChildren,
    ContractorContractorIdDocumentsRoute: ContractorContractorIdDocumentsRoute,
    ContractorContractorIdHistoryRoute: ContractorContractorIdHistoryRoute,
    ContractorContractorIdIndexRoute: ContractorContractorIdIndexRoute,
    ContractorContractorIdEmployeesEmployeeIdRoute:
      ContractorContractorIdEmployeesEmployeeIdRouteWithChildren,
    ContractorContractorIdEmployeesAddRoute:
      ContractorContractorIdEmployeesAddRoute,
    ContractorContractorIdForestCrewsForestCrewIdRoute:
      ContractorContractorIdForestCrewsForestCrewIdRouteWithChildren,
    ContractorContractorIdForestCrewsAddRoute:
      ContractorContractorIdForestCrewsAddRoute,
    ContractorContractorIdMachinesAddRoute:
      ContractorContractorIdMachinesAddRoute,
    ContractorContractorIdEditIndexRoute: ContractorContractorIdEditIndexRoute,
    ContractorContractorIdSendSMSIndexRoute:
      ContractorContractorIdSendSMSIndexRoute,
    ContractorContractorIdMachinesMachineIdEditRoute:
      ContractorContractorIdMachinesMachineIdEditRoute,
  }

const ContractorContractorIdRouteWithChildren =
  ContractorContractorIdRoute._addFileChildren(
    ContractorContractorIdRouteChildren,
  )

interface ForestownerForestownerIdRouteChildren {
  ForestownerForestownerIdAssignmentsRoute: typeof ForestownerForestownerIdAssignmentsRoute
  ForestownerForestownerIdDocumentsRoute: typeof ForestownerForestownerIdDocumentsRoute
  ForestownerForestownerIdEconomyRoute: typeof ForestownerForestownerIdEconomyRoute
  ForestownerForestownerIdFscRoute: typeof ForestownerForestownerIdFscRoute
  ForestownerForestownerIdHistoryRoute: typeof ForestownerForestownerIdHistoryRoute
  ForestownerForestownerIdIndexRoute: typeof ForestownerForestownerIdIndexRoute
  ForestownerForestownerIdPropertyAddRoute: typeof ForestownerForestownerIdPropertyAddRoute
  ForestownerForestownerIdPropertySupplierNumberRoute: typeof ForestownerForestownerIdPropertySupplierNumberRoute
  ForestownerForestownerIdContactpreferencesIndexRoute: typeof ForestownerForestownerIdContactpreferencesIndexRoute
  ForestownerForestownerIdEditIndexRoute: typeof ForestownerForestownerIdEditIndexRoute
  ForestownerForestownerIdPropertyIndexRoute: typeof ForestownerForestownerIdPropertyIndexRoute
  ForestownerForestownerIdSendSMSIndexRoute: typeof ForestownerForestownerIdSendSMSIndexRoute
  ForestownerForestownerIdShareownershipIndexRoute: typeof ForestownerForestownerIdShareownershipIndexRoute
  ForestownerForestownerIdPropertyProtectedAreaEditRoute: typeof ForestownerForestownerIdPropertyProtectedAreaEditRoute
  ForestownerForestownerIdContactpreferencesExceptionsIndexRoute: typeof ForestownerForestownerIdContactpreferencesExceptionsIndexRoute
  ForestownerForestownerIdPropertyPropertyIdIndexRoute: typeof ForestownerForestownerIdPropertyPropertyIdIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute
  ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute: typeof ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute
  ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute: typeof ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute
}

const ForestownerForestownerIdRouteChildren: ForestownerForestownerIdRouteChildren =
  {
    ForestownerForestownerIdAssignmentsRoute:
      ForestownerForestownerIdAssignmentsRoute,
    ForestownerForestownerIdDocumentsRoute:
      ForestownerForestownerIdDocumentsRoute,
    ForestownerForestownerIdEconomyRoute: ForestownerForestownerIdEconomyRoute,
    ForestownerForestownerIdFscRoute: ForestownerForestownerIdFscRoute,
    ForestownerForestownerIdHistoryRoute: ForestownerForestownerIdHistoryRoute,
    ForestownerForestownerIdIndexRoute: ForestownerForestownerIdIndexRoute,
    ForestownerForestownerIdPropertyAddRoute:
      ForestownerForestownerIdPropertyAddRoute,
    ForestownerForestownerIdPropertySupplierNumberRoute:
      ForestownerForestownerIdPropertySupplierNumberRoute,
    ForestownerForestownerIdContactpreferencesIndexRoute:
      ForestownerForestownerIdContactpreferencesIndexRoute,
    ForestownerForestownerIdEditIndexRoute:
      ForestownerForestownerIdEditIndexRoute,
    ForestownerForestownerIdPropertyIndexRoute:
      ForestownerForestownerIdPropertyIndexRoute,
    ForestownerForestownerIdSendSMSIndexRoute:
      ForestownerForestownerIdSendSMSIndexRoute,
    ForestownerForestownerIdShareownershipIndexRoute:
      ForestownerForestownerIdShareownershipIndexRoute,
    ForestownerForestownerIdPropertyProtectedAreaEditRoute:
      ForestownerForestownerIdPropertyProtectedAreaEditRoute,
    ForestownerForestownerIdContactpreferencesExceptionsIndexRoute:
      ForestownerForestownerIdContactpreferencesExceptionsIndexRoute,
    ForestownerForestownerIdPropertyPropertyIdIndexRoute:
      ForestownerForestownerIdPropertyPropertyIdIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipIndexRoute,
    ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute:
      ForestownerForestownerIdPropertyPropertyIdProtectedAreaEditRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipEndOwnershipIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipForestOwnerAssociationIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipPartialTransferIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipPartnerIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipTerminateTransferIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipPartnerAddIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveIndexRoute,
    ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute:
      ForestownerForestownerIdShareownershipEditShareOwnershipPartnerRemoveSummaryIndexRoute,
  }

const ForestownerForestownerIdRouteWithChildren =
  ForestownerForestownerIdRoute._addFileChildren(
    ForestownerForestownerIdRouteChildren,
  )

interface TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteChildren {
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute
}

const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteChildren: TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteChildren =
  {
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdAssortmentCategoriesIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdEditIndexRoute,
  }

const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteWithChildren =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute._addFileChildren(
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteChildren,
  )

interface TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteChildren {
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteWithChildren
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute
}

const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteChildren: TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteChildren =
  {
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsPricePeriodIdRouteWithChildren,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdEditIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdMainAssortmentsIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCopyIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdPricePeriodsCreateIndexRoute,
  }

const TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteWithChildren =
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute._addFileChildren(
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteChildren,
  )

interface TimberbuyerTimberBuyerIdRouteChildren {
  TimberbuyerTimberBuyerIdIndexRoute: typeof TimberbuyerTimberBuyerIdIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteWithChildren
  TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute
  TimberbuyerTimberBuyerIdContactpreferencesIndexRoute: typeof TimberbuyerTimberBuyerIdContactpreferencesIndexRoute
  TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute: typeof TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute
  TimberbuyerTimberBuyerIdEditIndexRoute: typeof TimberbuyerTimberBuyerIdEditIndexRoute
  TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute: typeof TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute
}

const TimberbuyerTimberBuyerIdRouteChildren: TimberbuyerTimberBuyerIdRouteChildren =
  {
    TimberbuyerTimberBuyerIdIndexRoute: TimberbuyerTimberBuyerIdIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsSalesAgreementIdRouteWithChildren,
    TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsRegisterRoute,
    TimberbuyerTimberBuyerIdContactpreferencesIndexRoute:
      TimberbuyerTimberBuyerIdContactpreferencesIndexRoute,
    TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute:
      TimberbuyerTimberBuyerIdDeliveryLocationsIndexRoute,
    TimberbuyerTimberBuyerIdEditIndexRoute:
      TimberbuyerTimberBuyerIdEditIndexRoute,
    TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute:
      TimberbuyerTimberBuyerIdSalesAgreementsIndexRoute,
  }

const TimberbuyerTimberBuyerIdRouteWithChildren =
  TimberbuyerTimberBuyerIdRoute._addFileChildren(
    TimberbuyerTimberBuyerIdRouteChildren,
  )

interface FrameworkForestownerForestownerIdRouteChildren {
  FrameworkForestownerForestownerIdAssignmentsRoute: typeof FrameworkForestownerForestownerIdAssignmentsRoute
  FrameworkForestownerForestownerIdDocumentsRoute: typeof FrameworkForestownerForestownerIdDocumentsRoute
  FrameworkForestownerForestownerIdEconomyRoute: typeof FrameworkForestownerForestownerIdEconomyRoute
  FrameworkForestownerForestownerIdFscRoute: typeof FrameworkForestownerForestownerIdFscRoute
  FrameworkForestownerForestownerIdHistoryRoute: typeof FrameworkForestownerForestownerIdHistoryRoute
  FrameworkForestownerForestownerIdPropertyRoute: typeof FrameworkForestownerForestownerIdPropertyRoute
  FrameworkForestownerForestownerIdShareownershipRoute: typeof FrameworkForestownerForestownerIdShareownershipRoute
  FrameworkForestownerForestownerIdIndexRoute: typeof FrameworkForestownerForestownerIdIndexRoute
}

const FrameworkForestownerForestownerIdRouteChildren: FrameworkForestownerForestownerIdRouteChildren =
  {
    FrameworkForestownerForestownerIdAssignmentsRoute:
      FrameworkForestownerForestownerIdAssignmentsRoute,
    FrameworkForestownerForestownerIdDocumentsRoute:
      FrameworkForestownerForestownerIdDocumentsRoute,
    FrameworkForestownerForestownerIdEconomyRoute:
      FrameworkForestownerForestownerIdEconomyRoute,
    FrameworkForestownerForestownerIdFscRoute:
      FrameworkForestownerForestownerIdFscRoute,
    FrameworkForestownerForestownerIdHistoryRoute:
      FrameworkForestownerForestownerIdHistoryRoute,
    FrameworkForestownerForestownerIdPropertyRoute:
      FrameworkForestownerForestownerIdPropertyRoute,
    FrameworkForestownerForestownerIdShareownershipRoute:
      FrameworkForestownerForestownerIdShareownershipRoute,
    FrameworkForestownerForestownerIdIndexRoute:
      FrameworkForestownerForestownerIdIndexRoute,
  }

const FrameworkForestownerForestownerIdRouteWithChildren =
  FrameworkForestownerForestownerIdRoute._addFileChildren(
    FrameworkForestownerForestownerIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CatchAllRoute: CatchAllRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  AssortmentSearchRoute: AssortmentSearchRoute,
  AssortmentTypesRoute: AssortmentTypesRoute,
  ContractorContractorIdRoute: ContractorContractorIdRouteWithChildren,
  ContractorRegisterRoute: ContractorRegisterRoute,
  ContractorSearchRoute: ContractorSearchRoute,
  ForestownerForestownerIdRoute: ForestownerForestownerIdRouteWithChildren,
  ForestownerAuthTestRoute: ForestownerAuthTestRoute,
  ForestownerRegisterRoute: ForestownerRegisterRoute,
  ForestownerSearchRoute: ForestownerSearchRoute,
  FrameworkSearchRoute: FrameworkSearchRoute,
  SearchEditRoute: SearchEditRoute,
  ShareholderRegisterRoute: ShareholderRegisterRoute,
  TimberbuyerTimberBuyerIdRoute: TimberbuyerTimberBuyerIdRouteWithChildren,
  TimberbuyerRegisterRoute: TimberbuyerRegisterRoute,
  TimberbuyerSearchRoute: TimberbuyerSearchRoute,
  AssortmentIndexRoute: AssortmentIndexRoute,
  BulkSmsIndexRoute: BulkSmsIndexRoute,
  ForestownerIndexRoute: ForestownerIndexRoute,
  FrameworkIndexRoute: FrameworkIndexRoute,
  SearchIndexRoute: SearchIndexRoute,
  TimberbuyerIndexRoute: TimberbuyerIndexRoute,
  FrameworkForestownerForestownerIdRoute:
    FrameworkForestownerForestownerIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
